export const styles = (theme) => ({
    titleContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '1rem'
    },
    alertDialogsContainer: {
        display: 'flex',
        gap: '16px',
        flexDirection: 'row'
    },
    datesRowContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
    buttonsContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '1rem',
    },
    totalesTable: {
        width: 'auto',
        borderCollapse: 'collapse',
        marginTop: '10px'
    },
    totalesCell: {
        padding: '3px 5px',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        color: theme.palette.text.secondary,
        whiteSpace: 'nowrap',
        textAlign: 'left',
        paddingRight: '100px'
    },
    totalesValueCell: {
        padding: '3px 5px',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        color: theme.palette.text.primary,
        whiteSpace: 'nowrap',
        textAlign: 'right',
        paddingBottom: '2px'
    },
    totalesRowCell: {
        padding: '3px 5px',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        color: theme.palette.text.primary,
        whiteSpace: 'nowrap',
        textAlign: 'left',
        paddingRight: '100px',
        fontSize: '18px',
        fontWeight: 'bold',
        paddingTop: '15px',
        lineHeight: '1.2'
    },
    totalesRowValueCell: {
        padding: '3px 5px',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        color: theme.palette.text.primary,
        whiteSpace: 'nowrap',
        textAlign: 'right',
        fontSize: '18px',
        fontWeight: 'bold',
        paddingTop: '15px',
        lineHeight: '1.2'
    },
    totalesRegularRowCell: {
        paddingBottom: '2px'
    },
    freeOrderCommentContainer: {
        marginTop: '1rem',
        '& .MuiGrid-item': {
            flexBasis: '100%',
            maxWidth: '100%'
        }
    },
});